import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "html-config",
    templateUrl: "./html-config.view.html",
    providers: []
})
export class HtmlConfigView implements OnInit {
    ddfs: Array<any>;
    ddfData: Array<any> = [];
    ddfGroups: Array<string> = [];
    baseUrl = "";
    textConfig: any = {};
    ddfJson = "session-ddf.json";
    templateLabel = 'template';

    constructor(
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.ddfGroups = ["Session", "Webinar", "Event"];
            this.baseUrl = this.sharedService.sessionUrl;

            if (this.baseUrl == "mysession") {
                this.ddfJson = "my-session-ddf.json";
            }
            if (this.baseUrl == "highlighted" || this.baseUrl == "promoted") {
                this.ddfJson = "session-without-instance-ddf.json";
                this.ddfGroups = ["Session"]
            }

            if(this.router.url.search('add-to-calendar-config')>-1) {
                this.ddfGroups = ["Session", "Webinar", "Event"];
                this.sharedService.expansionStyle = 'calendar';
            }
            
            if(this.router.url.search('add-to-calendar-config')>-1 && !this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ]) {
                this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
                ] = {
                textConfig: this.sharedService.addEventtoCalendarConfig
                }
            }

            this.textConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].catalogConfig[
                this.sharedService.expansionStyle
            ].textConfig;

            if(this.router.url.search('html-private-config')>-1 && !this.textConfig.privateTemplate) {
                if(this.baseUrl == "highlighted" || this.baseUrl == "promoted") {
                    this.textConfig.privateTemplate = this.sharedService.expansionStyle == 'header' ? this.sharedService.highlightedOrPromotedTemplate : this.sharedService.expandHighlightedOrPromotedTemplate;
                } else {
                    this.textConfig.privateTemplate = this.sharedService.expansionStyle == 'header' ? this.sharedService.generalSessionTemplate : this.sharedService.expandGeneralSessionTemplate;
                }
                this.templateLabel = 'privateTemplate';
            } else if(this.router.url.search('html-private-config')>-1) {
                this.templateLabel = 'privateTemplate';
            }

            if(this.baseUrl == 'general' && this.templateLabel == 'privateTemplate') {
                this.ddfGroups.push("Registration");
            }

            this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
                if (data != null) {
                    this.ddfData = data;
                    if (
                        this.router.url.search('add-to-calendar-config') == -1 &&
                        this.sharedService.sessionCustomFields != null &&
                        this.sharedService.sessionCustomFields.length > 0
                    ) {
                        this.ddfGroups.push("Session custom field");
                        this.sharedService.sessionCustomFields.forEach((cf) => {
                            if (this.baseUrl == "mysession") {
                                if (cf.questionTypeId != 19) {
                                    this.ddfData.push({
                                        label: cf.name,
                                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                        type: "Session custom field"
                                    });
                                }
                            } else {
                                this.ddfData.push({
                                    label: cf.name,
                                    key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                    type: "Session custom field"
                                });
                            }
                        });
                    }

                    this.fetchDdfs();
                }
            });
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.ddfGroups = ["Speaker"];
            this.textConfig = this.sharedService.speakerLayoutConfig.catalogConfig[
                this.sharedService.expansionStyle
            ].textConfig;
            this.localDataService.getJSON("speaker-ddf.json").subscribe((data) => {
                if (data != null) {
                    this.ddfData = data;
                    if (
                        this.sharedService.speakerCustomFields != null &&
                        this.sharedService.speakerCustomFields.length > 0
                    ) {
                        this.ddfGroups.push("Speaker custom field");
                        this.sharedService.speakerCustomFields.forEach((cf) => {
                            this.ddfData.push({
                                label: cf.name,
                                key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                                type: "Speaker custom field"
                            });
                        });
                    }

                    this.fetchDdfs();
                }
            });
        }
    }

    setHeader(ev) {
        this.textConfig[this.templateLabel] = ev;
    }

    fetchDdfs() {
        let ddfResults = [];
        for (let i = 0; i < this.ddfData.length; i++) {
            const ddf = this.ddfData[i];
            if(this.baseUrl == 'general' && this.templateLabel == 'template' && (ddf.type == 'REGISTRATION' || (ddf.type == 'WEBINAR' && ddf.label == 'Join URL'))) {
                continue;
            }
            let groupName = ddf.type.toLowerCase();
            groupName = groupName.charAt(0).toUpperCase() + groupName.substring(1);
            const tinymceDdf = {
                group: groupName,
                title: ddf.label.trim(),
                variableKey: ddf.key.substring(2, ddf.key.length - 2),
                variableValue: ddf.label.trim()
            };
            ddfResults.push(tinymceDdf);
        }
        this.ddfs = ddfResults;
    }
}
